module.exports = __webpack_public_path__ + "assets/img/advanced-streamline-money-icon.4534a08d.svg";